export default __webpack_public_path__ + "static/media/NG.bf105e21.svg";